var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"platforms"},React.createElement("path",{"id":"Subtract","d":"M11.2216 19.9261C16.1683 19.3236 20 15.1093 20 10C20 4.47715 15.5228 0 10 0C4.47715 0 0 4.47715 0 10C0 14.6873 3.22493 18.6214 7.57703 19.7045V13.0707H5.52409V9.99517H7.57703V8.64405C7.57703 7.34715 7.82748 5.90243 8.76244 4.92922C9.79987 3.84935 11.8737 3.3742 14.6528 3.9507V6.72399C13.1621 6.63643 12.3824 6.70731 11.8737 7.08259C11.3459 7.47188 11.2216 8.1292 11.2216 8.66907V9.99517H14.4926L13.9237 13.0707H11.2216V19.9261Z","fill":"#ADB5BD"})));
}

Facebook.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
